import { render, staticRenderFns } from "./AppScoreDialog.vue.js?vue&type=template&id=78d652fe!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppScoreDialog.vue?vue&type=template&id=78d652fe"
import script from "./AppScoreDialog.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppScoreDialog.vue?vue&type=script&lang=js"
export * from "./AppScoreDialog.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/index.js??vue-loader-options!./AppScoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports